<template>
  <div class="bg-white px-3" style="margin: -20px; margin-top: -1rem; margin-bottom: 0 !important">
    <div class="add_tits" ref="titles">
      <el-form class="form-inlines" :inline="true">
        <el-form-item>
          <el-date-picker v-model="values" type="daterange" size="small" :clearable="false" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="search_day">日对比</el-button>
          <el-button type="primary" size="small" @click="submitTime(1)">昨</el-button>
          <el-button type="primary" size="small" @click="submitTime(3)">3</el-button>
          <el-button type="primary" size="small" @click="submitTime(7)">7</el-button>
          <el-button type="primary" size="small" @click="submitTimeBy">本月</el-button>
          <el-button type="primary" size="small" @click="submitTimeSy">上月</el-button>
        </el-form-item>
        <el-form-item>
          <el-date-picker v-model="zdb_value1" size="small" type="week" format="yyyy 第 WW 周" ref="week1" placeholder="开始周"
            value-format="yyyy-MM-dd" :clearable="false" id="week1" class="zwidth"></el-date-picker>
          <el-date-picker v-model="zdb_value2" size="small" type="week" format="yyyy 第 WW 周"  ref="week2"  placeholder="结束周"
            value-format="yyyy-MM-dd" :clearable="false" id="week2" class="zwidth"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="search_week">周对比</el-button>
        </el-form-item>
        <el-form-item>
          <el-date-picker v-model="ydb_value1" size="small" type="month" placeholder="开始月" class="ywidth"
            value-format="yyyy-MM" :clearable="false" id="month1"></el-date-picker>
          <el-date-picker v-model="ydb_value2" size="small" type="month" placeholder="结束月" class="ywidth"
            value-format="yyyy-MM" :clearable="false" id="month2"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="search_month">月对比</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <el-table :data="tableData" ref="table" v-loading="loading" border :height="Heighttab" :cell-style="cellStyle"
        :row-style="rowStyle" :header-cell-class-name='headerstyle'>
        <el-table-column v-for="item in header" :key="item.key" :label="item.name" align="center"
          :fixed="item.lock?true:false" :width="item.width?item.width:''">
          <el-table-column v-show="item.child.length>0" v-for="itemed in item.child" :key="itemed.key"
            :fixed="item.lock?true:false" :label="itemed.name" align="center" :width="itemed.width">
            <template slot-scope="{row}">
              <span
                :class="parseFloat(tableData[0][itemed.key])>parseFloat(row[itemed.key])?'red':''">{{row[itemed.key]}}</span>
            </template>
          </el-table-column>
          <template slot-scope="{row}" v-show="item.child.length<1">
            <span :class="parseFloat(tableData[0][item.key])>parseFloat(row[item.key])?'red':''">
              {{row[item.key]  }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        values: [],
        zdb_value1: '',
        zdb_value2: '',
        ydb_value1: '',
        ydb_value2: '',
        loading: false,
        header: [],
        tableData: [],
        Heighttab: null,
      }
    },
    mounted() {
      let that = this;
      that.gettime();
      that.getheight();
    },
    methods: {
      gettime() {
        this.submitTime(7);
      },
      getheight() {
        let that = this;
        that.$nextTick(() => {
          var titles = that.$refs.titles.offsetHeight;
          that.Heighttab = window.innerHeight - titles - 130;
          window.onresize = () => {
            var titles = that.$refs.titles.offsetHeight;
            that.Heighttab = window.innerHeight - titles - 130;
          };
        })
      },
      //获取n天前时间
      submitTime(n) {
        //开始时间
        var nowDate = new Date();

        let befDate = new Date(nowDate.getTime() - n * 24 * 3600 * 1000);
        let byear = befDate.getFullYear();
        let bmonth = befDate.getMonth() + 1;
        if (bmonth >= 1 && bmonth <= 9) {
          bmonth = "0" + bmonth;
        }
        let bday = befDate.getDate();
        if (bday >= 0 && bday <= 9) {
          bday = "0" + bday;
        }

        //截止时间
        let endDate = new Date(nowDate.getTime() - 1 * 24 * 3600 * 1000);
        let year = endDate.getFullYear();
        let month = endDate.getMonth() + 1;
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        let day = endDate.getDate();
        if (day >= 0 && day <= 9) {
          day = "0" + day;
        }

        //赋值
        let that = this;
        that.values = [
          byear + "-" + bmonth + "-" + bday,
          year + "-" + month + "-" + day
        ];
        that.search_day();
      },
      //本月
      submitTimeBy() {
        let that = this
        var date = new Date();
        var month = parseInt(date.getMonth() + 1);
        var day = date.getDate();
        if (month < 10) month = "0" + month;
        let yuechu = date.getFullYear() + "-" + month + "-" + '01';
        if (day == 1) {
          that.values = [yuechu, yuechu]
        } else {
          day = day - 1;
          if (day < 10) day = "0" + day;
          let yuedi = date.getFullYear() + "-" + month + "-" + day;
          that.values = [yuechu, yuedi]
        }
        that.search_day();
      },
      //上月
      submitTimeSy() {
        let nowDate = new Date();
        let year = nowDate.getFullYear();
        let month = nowDate.getMonth();
        nowDate.setDate(0);
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        let day = nowDate.getDate();
        if (day >= 0 && day <= 9) {
          day = "0" + day;
        }
        let endTime = `${year}-${month}-${day}`;
        this.nowTime = endTime; // 当前的时间点
        let befDate = new Date(nowDate.getTime());
        let byear = befDate.getFullYear();
        let bmonth = befDate.getMonth() + 1;
        if (bmonth >= 1 && bmonth <= 9) {
          bmonth = "0" + bmonth;
        }
        let bday = befDate.getDate();
        if (bday >= 0 && bday <= 9) {
          bday = "0" + bday;
        }
        let startTime = `${byear}-${bmonth}-${bday}`;
        let that = this;
        that.values = [
          byear + "-" + bmonth + "-" + "01",
          byear + "-" + bmonth + "-" + day
        ];
        that.search_day();
      },
      search_day() {
        let that = this;
        that.loading = true
        that.header = [];
        that.tableData = [];
        axios.post("/admin/getDoctorReport", {
            date1: that.values[0],
            date2: that.values[1],
            lx: 'day',
            week1: '',
            week2: '',
          }, {
            token: true
          })
          .then(response => {
            that.loading = false
            that.header = response.data.header
            that.tableData = response.data.data
            that.$nextTick(() => {
              that.$refs.table.doLayout();
            });
          })
          .catch(error => {})
      },
      search_week() {
        let that = this;
        that.loading = true
        var week1 = this.$refs.week1.displayValue
        var week2 =this.$refs.week2.displayValue
        that.header = [];
        that.tableData = [];
        if (week1 && week2) {
          var w1 = (week1.split('第 '))[1];
          w1 = w1.split(' 周')[0];
          var w2 = (week2.split('第 '))[1];
          w2 = w2.split(' 周')[0];
          axios.post("/admin/getDoctorReport", {
              date1: that.zdb_value1,
              date2: '',
              week1: w1,
              week2: w2,
              lx: 'week',
            }, {
              token: true
            })
            .then(response => {
              that.loading = false
              that.header = response.data.header
              that.tableData = response.data.data
              that.$nextTick(() => {
                that.$refs.table.doLayout();
              });
            })
            .catch(error => {})
        } else {
          this.$message({
            showClose: true,
            message: '请先选择第几周',
            type: 'warning'
          });
        }
      },
      search_month() {
        let that = this;
        that.loading = true
        that.header = [];
        that.tableData = [];
        if (this.ydb_value1 && this.ydb_value2) {
          axios.post("/admin/getDoctorReport", {
              date1: that.ydb_value1,
              date2: that.ydb_value2,
              week1: '',
              week2: '',
              lx: 'month',
            }, {
              token: true
            })
            .then(response => {
              that.loading = false
              that.header = response.data.header
              that.tableData = response.data.data
              that.$nextTick(() => {
                that.$refs.table.doLayout();
              });
            })
            .catch(error => {})
        } else {
          that.loading = false
          this.$message({
            showClose: true,
            message: '请先选择月份',
            type: 'warning'
          });
        }
      },
      cellStyle({
        row,
        column,
        rowIndex,
        columnIndex
      }) {
      
        if (columnIndex >= 4 && columnIndex <= 7 || columnIndex >= 9 && columnIndex <= 11) {
          return "background:#D9EDF7";
        } else {
          return "background:#f5f5f5";
        }
      },
      headerstyle({row, column, rowIndex, columnIndex}) {
         if (rowIndex == 0&&columnIndex==4||rowIndex == 0&&columnIndex==2||rowIndex == 1&&columnIndex>=3&&columnIndex<=6||rowIndex == 1&&columnIndex>=7&&columnIndex<=9 ) {
          return "bgc1";
        } else {
          return "bgc2";
        }
      },
      rowStyle({
        row,
        rowIndex
      }) {},
      isInteger(obj) {
        return obj % 1 === 0
      },
    },
  }
</script>

<style lang='scss' scoped>
  ::v-deep .el-table .bgc1 {
    background-color: #D9EDF7 !important;
  }

  ::v-deep .el-table .bgc2 {
    background-color: #f5f5f5 !important;
  }
</style>